import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import Paper from "@material-ui/core/Paper";
import Step from "@material-ui/core/Step";
import StepContent from "@material-ui/core/StepContent";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import PersonAddOutlinedIcon from "@material-ui/icons/PersonAddOutlined";
import KeyIcon from "@material-ui/icons/VpnKey";
// import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import clsx from "clsx";
import MaterialTable from "material-table";
import React, { useEffect, useState } from "react";
import { error } from "../../../../store/notification/actions";
import { getSessionData } from "../../base/helper/baseHelper";
import Base from "../../base/views/base";
import Popup from "../../base/views/Popup";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter";
import AddUserBasics from "./AddUserBasics";
import AddUserLicense from "./AddUserLicense";
import AddUserReview from "./AddUserReview";
import { AdminMenuListItems } from "./AdminMenuListItems";
import EditActiveUser from "./EditActiveUser";
import {
  AddActiveUser,
  getActiveUsers,
  VerifyUniqueUserEmail,
} from "./Helper/activeUserHelper";
import { SendForgotPasswordMail } from "../../ForgotPassword/helper/forgotPasswordHelper";
import SettingsIcon from "@material-ui/icons/Settings";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
    },
  },

  rootstep: {
    width: "100%",
  },
  pricingheader: {
    marginTop: theme.spacing(2),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },

  card: {
    height: 400,
    width: "100%",
    maxWidth: 195,
    position: "relative",
    borderRadius: 16,
    display: "flex",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    flexDirection: "column",
    paddingTop: 4,
    paddingBottom: 4,
    "&:last-child": {
      paddingRight: 5,
    },
    flexShrink: 0,
    marginRight: theme.spacing(5),
  },
  cardPricing: {
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    marginBottom: theme.spacing(2),
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
  },
  cardHeader: {
    fontSize: "small",
  },
  cardpaidlist: {
    paddingTop: 5,
    justifyContent: "center",
    paddingLeft: 10,
  },
  cardpaid: {
    paddingTop: 2,
    paddingLeft: 2,
    fontSize: "small",
    justifyContent: "center",
  },
  planswitcher: {
    paddingBottom: 12,
    paddingTop: 4,
  },
  showallplan: {
    paddingBottom: 12,
    paddingTop: 10,
    justifyContent: "center",
    display: "flex",
  },
  cardpaidlisticon: {
    position: "relative",
    top: 8,
  },
  gridlisticon: {
    position: "relative",
    left: 25,
  },
  appBar: {
    backgroundColor: "rgba(255,255,255,0.5)",
  },
  title: {
    flexGrow: 1,
    color: "rgba(0, 0, 0, 0.7);",
  },
  plantable: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    marginBottom: "1%",
  },
  plantable2: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    marginBottom: "1%",
  },
  plantableheader: {
    alignItems: "center",
    display: "inline-flex",
    flexWrap: "Wrap",
    justifyContent: "left",
  },
  list: {
    width: "35vw",
  },
  fullList: {
    width: "auto",
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    display: "flex",
    justifyContent: "center",
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "self-start",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  commingsoon: {
    border: "2px solid #0b8043",
    borderRadius: 4,
    fontSize: "small",
    lineHeight: 1.2,
    marginTop: 5,
    marginLeft: 10,
    padding: 5,
    textAlign: "center",
  },
  bgcontainer: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
  },
  button: {
    // color : "white",
    // backgroundColor : "rgba(128,128,128,0.2)",
    marginRight: "1rem",
    borderRadius: "0.5rem",
  },
}));

function getSteps() {
  return ["Basics", "Roles", "Review"];
}

export default function ActiveUsers() {
  const classes = useStyles();
  const [userBasicsError, setUserBasicsError] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [activeUsers, setActiveUsers] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);

  const [addUserData, setAddUserData] = useState({
    employeeid: "",
    firstname: "",
    lastname: "",
    emailid: "",
    autogeneratepassword: true,
    userpassword: "",
    roles: [],
    userexists: false,
    selectstores: [],
    selectemployee: null,
  });

  useEffect(() => {
    const userId = getSessionData({ key: "userId" });
    getActiveUsers(userId).then((res) => {
      setActiveUsers(res.data);
    });
  }, []);

  const validateUserBasicsError = (e, fieldValues = addUserData) => {
    let temp = { ...userBasicsError };

    if ("selectstores" in fieldValues) {
      temp.selectstores = !(
        fieldValues.selectstores && fieldValues.selectstores.length > 0
      )
        ? "Pharmacy is required"
        : "";
    }
    if ("firstname" in fieldValues) {
      temp.firstname =
        fieldValues.firstname === "" ? "First Name is required" : "";
    }
    if ("lastname" in fieldValues) {
      temp.lastname =
        fieldValues.lastname === "" ? "Last Name is required" : "";
    }
    if ("emailid" in fieldValues) {
      temp.emailid =
        fieldValues.emailid === ""
          ? "Email is required"
          : /$^|.+@.+..+/.test(fieldValues.emailid)
          ? ""
          : "Invalid Email.";
    }
    if ("userpassword" in fieldValues) {
      temp.userpassword =
        fieldValues.userpassword === "" &&
        fieldValues.autogeneratepassword === false
          ? "Password is required"
          : "";
    }
    setUserBasicsError({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const updateField = (e) => {
    e.preventDefault();
    setAddUserData({
      ...addUserData,
      [e.target.name]: e.target.value,
    });
  };

  const changePasswordtypefalse = () => {
    setAddUserData({
      ...addUserData,
      autogeneratepassword: false,
    });
  };

  const changePasswordtypetrue = () => {
    setAddUserData({
      ...addUserData,
      autogeneratepassword: true,
    });
  };

  const openInPopup = () => {
    // setRecordForEdit(item);
    setOpenPopup(true);
  };

  const handleReset = async () => {
    await SendForgotPasswordMail({
      user_email: recordForEdit.useremailid,
      redirect: true,
    }).then(() => {
      setRecordForEdit(null);
      setOpenPopup(false);
      setSelectedRow(null);
    });
  };

  const updateRoles = (role) => {
    const roles = addUserData.roles;
    const index = roles.findIndex((r) => r.storepk === role.storepk);
    if (index !== -1) roles[index] = role;
    else roles.push(role);
    setAddUserData({ ...addUserData, roles });
  };
  const addOrEdit = (users, resetForm) => {
    setActiveUsers(users);
    resetForm();
    setRecordForEdit(null);
    setOpenPopup(false);
    setSelectedRow(null);
  };

  const submitActiveUser = async () => {
    const newUser = await AddActiveUser(addUserData);
    if (newUser) {
      setActiveUsers([...activeUsers, newUser[0]]);
      setActiveStep(activeStep + 1);
    }
  };
  function getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return (
          <AddUserBasics
            addUserData={addUserData}
            setAddUserData={setAddUserData}
            inputpasswordchangefalse={changePasswordtypefalse}
            inputpasswordchangetrue={changePasswordtypetrue}
            inputchange={updateField}
            userDataError={userBasicsError}
          />
        );
      case 1:
        return (
          <AddUserLicense addUserData={addUserData} updateRoles={updateRoles} />
        );
      case 2:
        return <AddUserReview addUserData={addUserData} />;
      default:
        return "Unknown stepIndex";
    }
  }

  const handleNext = () => {
    if (activeStep === 0) {
      if (validateUserBasicsError()) {
        if (addUserData.emailid) {
          VerifyUniqueUserEmail(addUserData.emailid)
            .then((response) => {
              if (
                response &&
                response.data &&
                response.data.length > 0 &&
                response.data[0].fn_verifyuseremail === 1
              ) {
                error("Email id already exists");
                return false;
              } else {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
              }
            })
            .catch((err) => {
              error("duplicate email validation internal error occurred");
            });
        } else {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
      }
    } else if (activeStep === 1) {
      if (addUserData.roles.length !== addUserData.selectstores.length) {
        error("Please assign the role to proceed.");
      } else {
        setActiveStep(activeStep + 1);
      }
    } else if (activeStep === steps.length - 1) {
      submitActiveUser();
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const headCells = [
    { title: "First Name", field: "firstname", defaultSort: "asc" },
    { title: "Last Name", field: "lastname", defaultSort: "asc" },
    { title: "EmailId", field: "useremailid" },
  ];

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    if (open) {
      setAddUserData({
        ...addUserData,
        firstname: "",
        lastname: "",
        emailid: "",
        userexists: false,
        userpassword: "",
        selectstores: [],
        selectemployee: null,
      });
      setUserBasicsError({});
    }
    setState({ ...state, [anchor]: open });
    setActiveStep(0);
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
    >
      <div className={classes.toolbarIcon}>
        <IconButton onClick={toggleDrawer(anchor, false)}>
          <ChevronRightIcon />
        </IconButton>
      </div>
      <h2 style={{ display: "flex", justifyContent: "center", margin: "auto" }}>
        Add User
      </h2>
      <List>
        <div className={classes.rootstep}>
          <Stepper activeStep={activeStep} orientation="vertical">
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
                <StepContent>
                  <div>{getStepContent(index)}</div>
                  <div className={classes.actionsContainer}>
                    <div>
                      <Container component="main" maxWidth="lg">
                        <Grid container spacing={3}>
                          <Grid
                            item
                            xs={12}
                            className={classes.bg}
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <Button
                              style={{ marginTop: "1rem" }}
                              disabled={activeStep === 0}
                              onClick={handleBack}
                              className={classes.button}
                            >
                              Back
                            </Button>
                            <Button
                              style={{ marginTop: "1rem", backgroundColor : "rgb(22, 177, 255)" }}
                              variant="contained"
                              color="primary"
                              onClick={handleNext}
                              className={classes.button}
                            >
                              {activeStep === steps.length - 1
                                ? "Submit"
                                : "Next"}
                            </Button>
                          </Grid>
                        </Grid>
                      </Container>
                    </div>
                  </div>
                </StepContent>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length && (
            <Paper square elevation={0} className={classes.resetContainer}>
              <Container component="main" maxWidth="lg">
                <Grid container spacing={3}>
                  <Grid
                    item
                    xs={12}
                    className={classes.bg}
                    style={{ display: "flex", justifyContent: "Center" }}
                  >
                    <Typography>
                      <strong>User added Successfully</strong>
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    className={classes.bg}
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      onClick={toggleDrawer(anchor, false)}
                      className={classes.button}
                    >
                      Done
                    </Button>
                  </Grid>
                </Grid>
              </Container>
            </Paper>
          )}
        </div>
      </List>
    </div>
  );

  return (
    <div style={{ display: "flex" }}>
      <Base
        hideDrawer={true}
        menuItems={AdminMenuListItems}
        hidePharmacyButton={true}
      >
        <h1 style={{ marginTop: "3%" }}>Active Users</h1>
        <Container maxWidth="xl" className={classes.container}>
          {["right"].map((anchor) => (
            <React.Fragment key={anchor}>
              <Button
                className={classes.button}
                startIcon={<PersonAddOutlinedIcon />}
                onClick={toggleDrawer(anchor, true)}
                variant="contained"
                color="primary"
                style={{backgroundColor : "rgb(22, 177, 255)"}}
              >
                Add User
              </Button>
              <Drawer
                anchor={anchor}
                open={state[anchor]}
                onClose={toggleDrawer(anchor, false)}
              >
                {list(anchor)}
              </Drawer>
            </React.Fragment>
          ))}
          <Button
            className={classes.button}
            startIcon={<KeyIcon />}
            variant="contained"
            color="primary"
            style={{backgroundColor : recordForEdit ? "rgb(22, 177, 255)" : ""}}
            disabled={recordForEdit ? false : true}
            onClick={handleReset}
          >
            Reset Password
          </Button>
          <Button
            className={classes.button}
            startIcon={<SettingsIcon />}
            variant="contained"
            color="primary"
            style={{backgroundColor : recordForEdit ? "rgb(22, 177, 255)" : ""}}
            disabled={recordForEdit ? false : true}
            onClick={openInPopup}
          >
            Assign Roles
          </Button>
        </Container>
        <div className={classes.root}>
          <MaterialTable
            title="Active Users List"
            columns={headCells}
            data={activeUsers}
            options={{
              maxBodyHeight: 400,
              paging: true,
              pageSize: 25,
              pageSizeOptions: [25, 50, 100],
              headerStyle: {
                backgroundColor: "rgba(255,255,255,1)",
                color: "black",
              },
              rowStyle: (rowData) => ({
                backgroundColor:
                  selectedRow === rowData.tableData.id ? "#EEE" : "#FFF",
              }),
            }}
            onRowClick={(evt, selectedRow) => {
              setSelectedRow(selectedRow.tableData.id);
              setRecordForEdit(selectedRow);
            }}
          />
          <LandingPageFooter />
        </div>

        <Popup title="Assign Roles" openPopup={openPopup} setOpenPopup={setOpenPopup}>
          <EditActiveUser
            user
            recordForEdit={recordForEdit}
            addOrEdit={addOrEdit}
            setOpenPopup={setOpenPopup}
          />
        </Popup>
      </Base>
    </div>
  );
}
